export default "__VITE_ASSET__f63064a2__"